import { ArrowDown } from 'lucide-react';

function ScrollToBottomBtn({ visible, onClick }: { visible: boolean; onClick: () => void }) {
  if (!visible) return null;
  return (
    <button onClick={onClick}
      className="absolute bottom-4 right-4 w-10 h-10 bg-white border border-gray-200 rounded-full shadow-xl flex items-center justify-center text-gray-600 hover:bg-gray-100 hover:scale-105 transition-all z-10 focus:outline-none focus:ring-2 focus:ring-blue-500 animate-in fade-in slide-in-from-bottom-2">
      <ArrowDown size={18} />
    </button>
  );
}

export default ScrollToBottomBtn;
